"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignMediaAdaptationsDto = exports.CampaignMediaAssignmentDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class CampaignMediaAssignmentDto {
    displayId;
    assetId;
}
exports.CampaignMediaAssignmentDto = CampaignMediaAssignmentDto;
__decorate([
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], CampaignMediaAssignmentDto.prototype, "displayId", void 0);
__decorate([
    (0, class_validator_1.IsMongoId)(),
    __metadata("design:type", String)
], CampaignMediaAssignmentDto.prototype, "assetId", void 0);
/** Opt-in only. assetIds reference existing, authorized media records, never S3 keys. */
class CampaignMediaAdaptationsDto {
    version;
    summaryRevision;
    assetIds;
    assignments;
}
exports.CampaignMediaAdaptationsDto = CampaignMediaAdaptationsDto;
__decorate([
    (0, class_validator_1.Equals)(1),
    __metadata("design:type", Number)
], CampaignMediaAdaptationsDto.prototype, "version", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    __metadata("design:type", String)
], CampaignMediaAdaptationsDto.prototype, "summaryRevision", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(100),
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsMongoId)({ each: true }),
    __metadata("design:type", Array)
], CampaignMediaAdaptationsDto.prototype, "assetIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ArrayMinSize)(1),
    (0, class_validator_1.ArrayMaxSize)(10000),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => CampaignMediaAssignmentDto),
    __metadata("design:type", Array)
], CampaignMediaAdaptationsDto.prototype, "assignments", void 0);
